import PhoneCodesWorldWide  from 'app/shared/utils/phones-codes-world-wide';


export const phonePatternsMap = PhoneCodesWorldWide.reduce((acc, { code_phone, pattern }) => {
    acc[code_phone] = new RegExp(pattern);
    return acc;
  }, {} as { [key: string]: RegExp });